import { ReactComponent as DisableMinus } from '@/assets/img/disabled_minus_btn.svg';
import { ReactComponent as EnableMinus } from '@/assets/img/enable_minus_btn.svg';
import { ReactComponent as Plus } from '@/assets/img/enable_plus_btn.svg';
import { Style } from '@/components/style';
import { availableLocales } from '@/constants/locale';
import NumberEditModal from '@/ui/NumberEditModal';
import ModalUtils from '@/utils/modalUtils';
import { cloneDeep, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { RootStateOrAny, useSelector } from 'react-redux';
import './shareMealCondictionModal.scss';

const {
  alertColor,
  blackColor,
  primaryColor,
  backgroundColor,
  whiteColor,
  gray3Color,
  secondaryColor,
} = new Style().getUiConfig();

function ShareMealCondictionModal({
  show,
  handleClose,
  webStoreVo,
  orderVo,
  shareMealConditionInfo,
  setShareMealConditionInfo,
}) {
  const welcomeLocale = useSelector(
    (state: RootStateOrAny) => state.customizeWelcomeReducer.welcomeLocale
  );
  const [shareMealRule, setShareMealRule] = useState<any>({});

  const getShareMealCondictionMsg = () => {
    let msg = '';

    if (
      !isEmpty(welcomeLocale) &&
      !isEmpty(shareMealRule?.messages?.transMap)
    ) {
      const localeKey = availableLocales[welcomeLocale].lang;
      if (!isEmpty(shareMealRule?.messages?.transMap[localeKey])) {
        msg = shareMealRule.messages.transMap[localeKey];
        if (!isEmpty(msg)) return msg;
      }
    }
    if (isEmpty(shareMealRule?.message)) return msg;
    msg += shareMealRule.message;

    return msg;
  };

  useEffect(() => {
    if (isEmpty(webStoreVo)) return;
    const { genericRules } = webStoreVo;
    if (isEmpty(genericRules)) return;

    for (let i = 0; i < genericRules.length; i += 1) {
      const { type } = genericRules[i];
      if (type === 'SHARE_MEAL') {
        setShareMealRule(genericRules[i]);
        break;
      }
    }
  }, [webStoreVo]);

  const [tempShareMealConditionInfo, setTempShareMealConditionInfo] =
    useState<any>([]);

  useEffect(() => {
    if (isEmpty(shareMealConditionInfo)) return;
    setTempShareMealConditionInfo(cloneDeep(shareMealConditionInfo));
  }, [shareMealConditionInfo]);

  const plusEvent = (condictionId) => {
    setTempShareMealConditionInfo((prevList) =>
      prevList.map((item) =>
        Number(item.id) === Number(condictionId)
          ? { ...item, count: item.count + 1 }
          : item
      )
    );
  };

  const minusEvent = (condictionId) => {
    setTempShareMealConditionInfo((prevList) =>
      prevList.map((item) =>
        Number(item.id) === Number(condictionId) && item.count > 0
          ? { ...item, count: item.count - 1 }
          : item
      )
    );
  };

  const cancelledEvent = () => {
    setTempShareMealConditionInfo(shareMealConditionInfo);
    handleClose();
  };

  const confirmEvent = () => {
    setShareMealConditionInfo(tempShareMealConditionInfo);
    handleClose();
  };

  const getShareMealTranslateTitle = (shareMealCondition) => {
    let msg = '';

    if (
      !isEmpty(welcomeLocale) &&
      !isEmpty(shareMealCondition?.titles?.transMap)
    ) {
      const localeKey = availableLocales[welcomeLocale].lang;
      if (!isEmpty(shareMealCondition?.titles?.transMap[localeKey])) {
        msg = shareMealCondition.titles.transMap[localeKey];
        if (!isEmpty(msg)) return msg;
      }
    }
    if (isEmpty(shareMealCondition?.title)) return msg;
    msg += shareMealCondition.title;

    return msg;
  };

  const getShareMealTranslateDesc = (shareMealCondition) => {
    let msg = '';

    if (
      !isEmpty(welcomeLocale) &&
      !isEmpty(shareMealCondition?.descs?.transMap)
    ) {
      const localeKey = availableLocales[welcomeLocale].lang;
      if (!isEmpty(shareMealCondition?.descs?.transMap[localeKey])) {
        msg = shareMealCondition.descs.transMap[localeKey];
        if (!isEmpty(msg)) return msg;
      }
    }
    if (isEmpty(shareMealCondition?.desc)) return msg;
    msg += shareMealCondition.desc;

    return msg;
  };

  return (
    <div className="modal-share-meal-condiction">
      <div
        className={`d-flex flex-column modal-share-meal-condiction-Container ${
          show
            ? 'modal-share-meal-condiction-Opened'
            : 'modal-share-meal-condiction-Closed'
        }`}
        style={{
          backgroundColor,
          maxWidth: '640px',
          margin: '0 auto' /* 使容器水平居中 */,
        }}
      >
        <div
          className="modal-share-meal-condiction-header fw-bolder d-flex justify-content-center align-items-center"
          style={{
            minHeight: '18%',
            width: '100%',
            fontSize: '18px',
          }}
        >
          <FormattedMessage id="common.shareMeal.modal.header.title" />
        </div>

        {/* 選擇人數 按鈕 list */}
        <div style={{ overflowY: 'scroll' }}>
          {/* 選擇人數 按鈕 */}
          {tempShareMealConditionInfo?.map((shareMealCondition: any) => (
            <div
              key={shareMealCondition.id}
              className="pt-2 pb-2 ps-4 pe-4 d-flex justify-content-around align-items-center"
              style={{
                borderBottom: `1px solid ${gray3Color}`,
                minHeight: '65px',
              }}
            >
              <NumberEditModal
                keyObject={{ id: shareMealCondition.id }}
                limitCount="99"
                itemCount={shareMealCondition.count}
                plus={() => {
                  plusEvent(shareMealCondition.id);
                }}
                minus={() => {
                  minusEvent(shareMealCondition.id);
                }}
              />
              <div className="" style={{ width: '65%' }}>
                <div className="fw-bolder" style={{ fontSize: '16px' }}>
                  {getShareMealTranslateTitle(shareMealCondition)}
                </div>
                <div style={{ color: gray3Color, fontSize: '12px' }}>
                  {getShareMealTranslateDesc(shareMealCondition)}
                </div>
              </div>
              <div
                className="d-flex justify-content-center"
                style={{
                  width: '35%',
                  border: `1px solid ${primaryColor}`,
                  borderRadius: '27px',
                }}
              >
                <div
                  className="d-flex justify-content-between"
                  style={{ width: '100%', padding: '5px' }}
                >
                  <div
                    role="presentation"
                    className="d-flex align-items-center"
                    onClick={() => {
                      minusEvent(shareMealCondition.id);
                    }}
                  >
                    {shareMealCondition?.count <= 0 ? (
                      <DisableMinus />
                    ) : (
                      <EnableMinus />
                    )}
                  </div>
                  <div
                    className="fw-bolder d-flex align-items-center"
                    role="presentation"
                    style={{
                      borderBottom: JSON.parse(webStoreVo?.uiConfig)
                        ?.isQuantityEditable
                        ? '1px solid'
                        : '',
                    }}
                    onClick={() => {
                      if (!JSON.parse(webStoreVo?.uiConfig)?.isQuantityEditable)
                        return;
                      ModalUtils.showModal(
                        `numberEditModalBackDrop-${shareMealCondition.id}`
                      );
                    }}
                  >
                    {shareMealCondition?.count ? shareMealCondition.count : 0}
                  </div>
                  <div
                    role="presentation"
                    className="d-flex align-items-center"
                    onClick={() => {
                      plusEvent(shareMealCondition.id);
                    }}
                  >
                    <Plus />
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* 共鍋費說明 文字 */}
          {!isEmpty(getShareMealCondictionMsg()) && (
            <div
              className="mt-auto"
              style={{
                height: '100%',
                width: '100%',
                padding: '20px',
                color: secondaryColor,
              }}
            >
              <div className="fw-bolder">
                <FormattedMessage id="common.shareMeal.title" />
              </div>
              <div style={{ whiteSpace: 'pre-wrap' }}>
                {getShareMealCondictionMsg()}
              </div>
            </div>
          )}
        </div>

        {/* 共鍋費 選擇人數 modal 確認取消 按鈕 */}
        <div
          className="mt-auto"
          style={{
            height: '18%',
            width: '100%',
          }}
        >
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              height: '100%',
              width: '100%',
              padding: '20px',
            }}
          >
            <button
              type="button"
              className="btn btn-lg  fw-bolder"
              style={{
                fontSize: '16px',
                width: '47%',
                border: '1px solid #5292D9',
                backgroundColor: '#FFF',
                borderRadius: '10px',
                color: '#5292D9',
                height: '46px',
              }}
              onClick={() => cancelledEvent()}
            >
              <FormattedMessage id="common.cancel" />
            </button>
            <button
              type="button"
              className="btn btn-lg fw-bolder"
              style={{
                fontSize: '16px',
                width: '47%',
                borderRadius: '10px',
                border: 'none',
                backgroundColor: '#5292D9',
                color: '#FFF',
                height: '46px',
              }}
              onClick={() => confirmEvent()}
            >
              <FormattedMessage id="common.confirm" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ShareMealCondictionModal.defaultProps = {};

ShareMealCondictionModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  webStoreVo: PropTypes.shape({
    isPostPayEnable: PropTypes.bool,
    shareConditionInfo: PropTypes.arrayOf(PropTypes.shape({})),
    genericRules: PropTypes.arrayOf(
      PropTypes.shape({ type: PropTypes.string })
    ),
  }).isRequired,
  orderVo: PropTypes.shape({}).isRequired,
  shareMealConditionInfo: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setShareMealConditionInfo: PropTypes.func.isRequired,
};

export default ShareMealCondictionModal;
